<div
  class="lds-spinner"
  [ngClass]="{
    'lds-spinner--invert-colour': invertColour,
    'lds-spinner--center': centered,
    small: small
  }"
>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
